import classNames from 'classnames';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
const SelectorItem = (props) => {
    const { t } = useTranslation();
    const refItem = useRef();
    const selectorContent = () => {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", { className: classNames('selector__menu__item__label') },
                props.label,
                props.enableOutofstockLabel && props.isOutOfStock ? ` - ${t('label.outofstock')}` : ''),
            props.children));
    };
    return (React.createElement("div", { className: "selector__menu-listitem", ref: refItem },
        React.createElement("label", { className: classNames('selector__menu__item', props.disabled && 'is-disabled', props.selected && 'selected', props.isInverted && 'inverted'), onMouseEnter: () => props.onHoverChange(true), onMouseLeave: () => props.onHoverChange(false) },
            React.createElement("input", { type: "radio", className: "selector__item-radio", onChange: () => {
                    props.onSelect(props.item, refItem.current);
                }, "aria-label": props.disabled ? t('selector.option.notavailable', { 0: props.label }) : props.label, disabled: !props.isNotAvailableSelectable && props.disabled ? true : false, name: `selector__item-${props.groupid}`, value: props.value, checked: props.selected ? true : false, tabIndex: props.disableFocus ? -1 : undefined }),
            props.children)));
};
SelectorItem.defaultProps = {
    enableOutofstockLabel: true,
    isNotAvailableSelectable: true,
    isInverted: false,
};
export default SelectorItem;
